<h2 class="title">Dołącz do ZGranego Grona</h2>
<div class="register-page-holder">
  <!-- Header Section -->
  <div class="register-header">

    <p>Utwórz konto i korzystaj z wszystkich korzyści programu lojalnościowego.</p>
  </div>

  <!-- Two Column Layout -->
  <div class="register-grid">

    <!-- Column 1: Registration Form -->
    <div class="register-column register-form-column">
      <div class="column-header">
        <mat-icon class="header-icon">person_add</mat-icon>
        <h2>Nowe konto</h2>
      </div>
      <div class="column-content">
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <!-- Email Field -->
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" />
            @if (registerForm.get('email')?.hasError('required')) {
              <mat-error>
                Email jest wymagany
              </mat-error>
            }
            @if (registerForm.get('email')?.hasError('email')) {
              <mat-error>
                Email jest nieprawidłowy
              </mat-error>
            }
          </mat-form-field>

          <!-- Password Field -->
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Hasło</mat-label>
            <input matInput type="password" formControlName="password" />
            @if (registerForm.get('password')?.hasError('required')) {
              <mat-error>
                Hasło jest wymagane
              </mat-error>
            }
            @if (registerForm.get('password')?.hasError('minlength')) {
              <mat-error>
                Hasło musi mieć co najmniej 8 znaków
              </mat-error>
            }
          </mat-form-field>

          <!-- Repassword Field -->
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Potwierdź Hasło</mat-label>
            <input matInput type="password" formControlName="repwd" />
            @if (registerForm.get('repwd')?.hasError('required')) {
              <mat-error>
                Hasło jest wymagane
              </mat-error>
            }
            @if (registerForm.get('repwd')?.hasError('passwordsMismatch')) {
              <mat-error>
                Hasła muszą być takie same
              </mat-error>
            }
          </mat-form-field>

          @if (false) {
            <!-- Privacy Policy Checkbox -->
            <div class="checkbox-container">
              <mat-checkbox formControlName="acceptPolicy">
                Oświadczam, że zapoznałem/am się z regulaminem Programu ZGrane Grono.
                <span (click)="$event.stopPropagation(); $event.preventDefault()" (mousedown)="$event.stopPropagation()">
                  <app-info-help [pageId]="'polityka_prywatnosci'" [title]="'Polityka prywatności'">
                  </app-info-help>
                </span>
              </mat-checkbox>

              @if (registerForm.get('acceptPolicy')?.invalid && registerForm.get('acceptPolicy')?.touched) {
                <div class="error-message"
                  >
                  Musisz zaakceptować politykę prywatności
                </div>
              }
            </div>
          }

          <!-- Submit Button -->
          <button mat-raised-button class="custom-button" type="submit" [disabled]="registerForm.invalid">
            Rejestracja
          </button>
        </form>
      </div>
    </div>

    <!-- Column 2: Registration Process -->
    <div class="register-column process-column">
      <div class="column-header">
        <mat-icon class="header-icon">info</mat-icon>
        <h2>Proces rejestracji</h2>
      </div>
      <div class="column-content">
        <div class="process-info">
          <p class="process-intro">
            <strong>Proces rejestracji przebiega następująco:</strong>
          </p>

          <div class="process-steps">
            <div class="process-step">
              <div class="step-number">1</div>
              <div class="step-content">
                <h4>Wypełnienie formularza</h4>
                <p>Podaj swój adres email i hasło</p>
              </div>
            </div>

            <div class="process-step">
              <div class="step-number">3</div>
              <div class="step-content">
                <h4>Potwierdzenie adresu e-mail</h4>
                <p>Sprawdź swoją skrzynkę pocztową</p>
              </div>
            </div>

            <div class="process-step">
              <div class="step-number">4</div>
              <div class="step-content">
                <h4>Logowanie do panelu</h4>
                <p>Zaloguj się używając swoich danych</p>
              </div>
            </div>
            
            <div class="process-step">
              <div class="step-number">2</div>
              <div class="step-content">
                <h4>Akceptacja regulaminu</h4>
                <p>Zapoznaj się i zaakceptuj politykę prywatności</p>
              </div>
            </div>



            <div class="process-step">
              <div class="step-number">5</div>
              <div class="step-content">
                <h4>Uzupełnienie profilu</h4>
                <p>Dodaj swoje dane osobowe</p>
              </div>
            </div>

            <div class="process-step">
              <div class="step-number">6</div>
              <div class="step-content">
                <h4>Informacje o rodzinie</h4>
                <p>Dodaj członków rodziny</p>
              </div>
            </div>

            <div class="process-step">
              <div class="step-number">7</div>
              <div class="step-content">
                <h4>Zamówienie karty</h4>
                <p>Zamów kartę lojalnościową</p>
              </div>
            </div>
          </div>

          <div class="benefits-section">
            <h4>Korzyści z członkostwa:</h4>
            <ul class="benefits-list">
              <li>Zniżki u partnerów programu</li>
              <li>Specjalne oferty i promocje</li>
              <li>Karta lojalnościowa dla całej rodziny</li>
              <li>Dostęp do wydarzeń kulturalnych</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>